<template>
    <p class="def-message-error">
        <svg class="def-message-error__icon"><use xlink:href="#svg-error-icon"></use></svg>
        <slot />
    </p>
</template>

<script>
export default {
    name: 'DefMessageError',
    selector: '.def-message-error',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.def-message-error{
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: var(--color-red);
    background-color: #F7EFEF;
    &__icon{
        display: block;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        fill: currentColor;
        flex-shrink: 0;
        transform: translateY(-2px);
    }
}
</style>